module.exports = __webpack_public_path__ + "static/media/wrap2.2cd97551.jpg";